export const DEFAULT_LOGO_SIZE = 25;

export const DEFAULT_MOBILE_LOGO_SIZE = 34;

export const UK_RISK_WARNING_BANNER_HEIGHT = 43;

export const UK_RISK_WARNING_BANNER_HEIGHT_MOBILE = 97;
